{
  "lastUpdatedAt": "2026-07-01T00:09:39.144Z",
  "lastFetchAttemptAt": "2026-07-01T00:09:39.144Z",
  "organization": null,
  "parseError": null,
  "fetchError": null
}